import React from 'react';

import CreateWizardLayout from '../../../../../components/CreateWizardLayout';
import { getAsset } from '../../../../../../../util/assets';

const FreemiumEventTutorialGroupVideoStep = () => {
  return (
    <CreateWizardLayout.Wrapper>
      <CreateWizardLayout.Content>
        <p className="text-center">
          Easily gather well wishes from others with Waldo’s AI-concierge and
          video creator. No editing skills required.
        </p>
        <img
          src={getAsset('/group-video-features-illustration.png')}
          alt=""
          width="365"
          className="mb-2 mx-auto d-flex"
        />
      </CreateWizardLayout.Content>
    </CreateWizardLayout.Wrapper>
  );
};

export default FreemiumEventTutorialGroupVideoStep;
